import { render, staticRenderFns } from "./FcPackingAgent.vue?vue&type=template&id=6f00ec84&"
import script from "./FcPackingAgent.vue?vue&type=script&lang=js&"
export * from "./FcPackingAgent.vue?vue&type=script&lang=js&"
import style0 from "./FcPackingAgent.vue?vue&type=style&index=0&id=6f00ec84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports